import React from "react";

const TermsConditions = () => {
  const styles = `
    body {
        background-color: #FFEDE3;
        margin: 0;
        padding: 0;
        min-height: 100vh;
        width: 100%;
    }

    .policy-container {
      font-family: 'Poppins', Arial, sans-serif;
      padding: 60px 20px;
      max-width: 900px;
      margin: 0 auto;
      color: #333;
    }

    .policy-header {
      text-align: center;
      margin-bottom: 40px;
      margin-top: 5rem;
    }

    .policy-header h1 {
      font-size: 2.5em;
      font-weight: 700;
      color: #ff6600;
      margin-bottom: 5px;
    }

    .policy-header p {
      color: #666;
      max-width: 600px;
      margin: 0 auto;
      font-size: 1em;
    }

    .policy-section {
      margin-bottom: 30px;
    }

    .policy-section h2 {
      font-size: 1.8em;
      font-weight: 600;
      color: #ff6600;
      margin-bottom: 15px;
      border-bottom: 2px solid #ff6600;
      padding-bottom: 5px;
      display: inline-block;
    }

    .policy-section ul {
      list-style-type: none;
      padding-left: 0;
    }

    .policy-section li {
      margin-bottom: 15px;
      line-height: 1.6;
    }

    .policy-section li strong {
      font-weight: 600;
    }

    .go-back-button {
      background-color: #f97316;
      color: white;
      padding: 1rem 2rem;
      font-size: 1.1em;
      border: none;
      border-radius: 2rem;
      cursor: pointer;
      font-weight: 600;
      display: block;
      margin: 40px auto 0;
      box-shadow: 0 4px 15px rgba(249, 115, 22, 0.3);
      transition: all 0.3s ease;
    }

    .go-back-button:hover {
      background-color: #ea580c;
      transform: scale(1.05);
      box-shadow: 0 6px 20px rgba(234, 88, 12, 0.4);
    }
  `;

  return (
    <div className="policy-container">
      <style>{styles}</style>
      <div className="policy-header">
        <h1>Terms & Conditions</h1>
        <p>
          Welcome to TIFFO Foods. By placing an order through our app or website, you agree to the following terms and conditions.
        </p>
      </div>

      <div className="policy-section">
        <h2>1. Service Scope</h2>
        <ul>
          <li>
            TIFFO Foods currently provides delivery only to schools and colleges via the TIFFO Foods App/Website.
          </li>
          <li>
            Orders outside this scope can be placed via Swiggy or Zomato.
          </li>
        </ul>
      </div>

      <div className="policy-section">
        <h2>2. Ordering & Payment</h2>
        <ul>
          <li>
            Orders must be placed by 11:00 AM for same-day delivery.
          </li>
          <li>
            Maximum order value per transaction is ₹1,199. Bulk or event orders require direct booking.
          </li>
          <li>
            All payments must be made in advance via UPI, cards, wallets, or net banking. Cash on delivery is not available.
          </li>
        </ul>
      </div>

      <div className="policy-section">
        <h2>3. Delivery</h2>
        <ul>
          <li>
            Orders will be delivered before or by 12:00 PM.
          </li>
          <li>
            Delivery timelines may vary due to external factors (traffic, weather, school/college access restrictions).
          </li>
          <li>
            TIFFO Foods is not liable for delays beyond its control.
          </li>
          <li>
            Our delivery responsibility ends once the order is successfully delivered to the designated school/college representative, security, or collection point.
          </li>
        </ul>
      </div>

      <div className="policy-section">
        <h2>4. Cancellations & Refunds</h2>
        <ul>
          <li>
            Orders can be canceled within 5 minutes of placing only.
          </li>
          <li>
            Refunds are processed as per our Cancellation & Refund Policy.
          </li>
        </ul>
      </div>

      <div className="policy-section">
        <h2>5. Food Safety & Packaging</h2>
        <ul>
          <li>
            All meals are prepared fresh, following FSSAI standards, and delivered in sealed, hygienic packaging.
          </li>
          <li>
            Customers are advised to consume food within 2 hours of delivery for best quality.
          </li>
        </ul>
      </div>
      
      <div className="policy-section">
        <h2>6. Customer Responsibility</h2>
        <ul>
          <li>
            Ensure correct delivery address and contact details while placing orders.
          </li>
          <li>
            Availability at the delivery location is mandatory to receive the order.
          </li>
        </ul>
      </div>

      <div className="policy-section">
        <h2>7. Liability</h2>
        <ul>
          <li>
            TIFFO Foods is not responsible for food spoilage due to late consumption, customer unavailability, or mishandling after delivery.
          </li>
          <li>
            Disputes are subject to Hyderabad, Telangana jurisdiction only.
          </li>
        </ul>
      </div>

      <div className="policy-section">
        <h2>8. Policy Updates</h2>
        <ul>
          <li>
            TIFFO Foods reserves the right to update these Terms & Conditions without prior notice.
          </li>
          <li>
            The latest version will always be available on our app/website.
          </li>
        </ul>
      </div>
      
      <button className="go-back-button" onClick={() => window.history.back()}>
        Go Back Before You Get Hungry
      </button>

    </div>
  );
};

export default TermsConditions;